'use strict';

angular.module('msLegacyActivities').controller('ActivityNextCtrl', ['activitySvc', 'activity', function (activitySvc, activity) {
  var vm = this;

  vm.activity = activity;
  // get a set of activities to recommend the user do next
  activitySvc.getUpNext(activity).then(function (activities) {
    vm.relatedActivities = activities;
  });
}]);